/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/mobility_2': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M10.25 22.415c.13 0 .259-.05.356-.149l1.051-1.072a.501.501 0 00-.006-.707.501.501 0 00-.707.008l-1.051 1.07a.501.501 0 00.357.85zM21.689 10.311c-1.869-1.869-9.566 2.906-9.566 2.906l6.659 6.66s4.777-7.699 2.907-9.566zM16.232 14a1.768 1.768 0 113.536 0 1.768 1.768 0 01-3.536 0zM14.35 17.02l-2.04 2.08a.493.493 0 00-.149.36c0 .13.06.261.149.351a.522.522 0 00.71 0l2.04-2.09a.47.47 0 00.15-.351.497.497 0 00-.15-.351.514.514 0 00-.71.001z"/><path pid="1" d="M28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646L31.354 16 28 12.646zM26 26H6V6h20v20z"/>'
  }
})
